import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mobile-menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MobileMenuItem = _resolveComponent("MobileMenuItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (menuItem) => {
      return (_openBlock(), _createBlock(_component_MobileMenuItem, {
        key: menuItem.name,
        label: menuItem.name,
        icon: menuItem.icon,
        to: menuItem.to
      }, null, 8, ["label", "icon", "to"]))
    }), 128))
  ]))
}